import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=5bb6e7dd"
import script from "./LoadData.vue?vue&type=script&lang=js"
export * from "./LoadData.vue?vue&type=script&lang=js"
import style0 from "./LoadData.vue?vue&type=style&index=0&id=5bb6e7dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports